export const FETCH_HOLDING_DATA_BEGIN="FETCH_HOLDING_DATA_BEGIN";
export const FETCH_HOLDING_DATA_SUCCESS="FETCH_HOLDING_DATA_SUCCESS";
export const FETCH_HOLDING_DATA_FAILURE="FETCH_HOLDING_DATA_FAILURE";

export const FETCH_HOLDING_SUMMARY_BEGIN="FETCH_HOLDING_SUMMARY_BEGIN";
export const FETCH_HOlDING_SUMMARY_SUCCESS="FETCH_HOlDING_SUMMARY_SUCCESS";
export const FETCH_HOLDING_SUMMARY_FAILURE="FETCH_HOLDING_SUMMARY_FAILURE";

export const FETCH_HOLDING_TOPLONGGRIDDATA_BEGIN="FETCH_HOLDING_TOPLONGGRIDDATA_BEGIN";
export const FETCH_HOlDING_TOPLONGGRIDDATA_SUCCESS="FETCH_HOlDING_TOPLONGGRIDDATA_SUCCESS";
export const FETCH_HOLDING_TOPLONGGRIDDATA_FAILURE="FETCH_HOLDING_TOPLONGGRIDDATA_FAILURE";


export const FETCH_HOLDING_SHORTLONGGRIDDATA_BEGIN="FETCH_HOLDING_SHORTLONGGRIDDATA_BEGIN";
export const FETCH_HOLDING_SHORTLONGGRIDDATA_SUCCESS="FETCH_HOLDING_SHORTLONGGRIDDATA_SUCCESS";
export const FETCH_HOLDING_SHORTLONGGRIDDATA_FAILURE="FETCH_HOLDING_SHORTLONGGRIDDATA_FAILURE";


export const FETCH_HOLDING_DATE_BEGIN="FETCH_HOLDING_DATE_BEGIN";
export const FETCH_HOlDING_DATE_SUCCESS="FETCH_HOlDING_DATE_SUCCESS";
export const FETCH_HOLDING_DATE_FAILURE="FETCH_HOLDING_DATE_FAILURE";